import * as React from "react";
import styled, { css } from "styled-components";
import { BetaBadge } from "components/common";
const Container = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings.xs};
  `
);
const LanguageLabel = ({ language, showBeta = false }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("span", { lang: language.code }, language.name), showBeta && language.beta && /* @__PURE__ */ React.createElement(BetaBadge, null));
export default LanguageLabel;
